import React from 'react';
import { Route, Switch } from 'react-router-dom';
import { ParentPaths } from 'src/components/AppRoutes/Parent/ParentPaths';
import {
  ChildCorpEditRoute,
  ParentCreateRoute,
  ParentEditRoute,
} from 'src/components/AppRoutes/ParentRoutes.layout';

export const ParentRoutes = (): JSX.Element => {
  return (
    <Switch>
      <Route exact path={ParentPaths.create} component={ParentCreateRoute} />
      <Route exact path={ParentPaths.edit} component={ParentEditRoute} />
      <Route
        exact
        path={ParentPaths.editChild}
        component={ChildCorpEditRoute}
      />
    </Switch>
  );
};
